export { default } from './Sidebar.container'



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js